export default function AuthSuccess() {
  return <></>;
}
